import { render, staticRenderFns } from "./PointsApi.vue?vue&type=template&id=ce873728&"
import script from "./PointsApi.vue?vue&type=script&lang=js&"
export * from "./PointsApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports